import { render } from "./PublicFooter.vue?vue&type=template&id=017c4ff9"
import script from "./PublicFooter.vue?vue&type=script&lang=js"
export * from "./PublicFooter.vue?vue&type=script&lang=js"

import "./PublicFooter.vue?vue&type=style&index=0&id=017c4ff9&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__